module.exports = __webpack_public_path__ + "img/exam-french.e0977c0f.png";